import { useTranslation } from 'react-i18next';

export default function ZonesProches() {
  const { t } = useTranslation('saintnicolas');

  const navigateTo = (path: string) => {
    if (window.REACT_APP_NAVIGATE) {
      window.REACT_APP_NAVIGATE(path);
    }
  };

  const zones = [
    { label: t('zone_saint_romuald'), path: '/secteurs/saint-romuald' },
    { label: t('zone_charny'), path: '/soumission-gratuite' },
    { label: t('zone_st_jean'), path: '/soumission-gratuite' },
    { label: t('zone_pintendre'), path: '/soumission-gratuite' },
  ];

  return (
    <section className="py-10 md:py-14 bg-soft-gray">
      <div className="max-w-4xl mx-auto px-4 md:px-6 lg:px-10 text-center">
        <h2 className="text-xl md:text-2xl font-manrope font-bold text-slate-primary mb-6 md:mb-8">
          {t('zones_h2')}
        </h2>

        <div className="flex flex-wrap items-center justify-center gap-3 md:gap-4">
          {zones.map((zone, idx) => (
            <span key={idx} className="flex items-center gap-2">
              <button
                onClick={() => navigateTo(zone.path)}
                className="text-sm md:text-base text-copper hover:text-copper-dark font-medium transition-colors whitespace-nowrap"
              >
                {zone.label}
              </button>
              {idx < zones.length - 1 && (
                <span className="text-gray-400">•</span>
              )}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}